<template>
  <div ref="scrollContainer" id="page-panel" class="box grow scrollable only-y reservations-page">
    <resize-observer @notify="__resizeHanlder" />

    <div class="reservations-shell">
      <div class="reservations-toolbar no-print">
        <div class="reservations-toolbar__title-wrap">
          <h1 class="reservations-toolbar__title">{{$t('reservation.reservations')}}</h1>
          <span class="reservations-toolbar__subtitle">{{$t('reservation.subtitle')}}</span>
        </div>

        <div class="reservations-toolbar__actions">
          <el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
            <el-radio-button label="list" class="mode-button">
              <i class="mdi mdi-view-list"></i>
            </el-radio-button>
            <el-radio-button label="tile" class="mode-button">
              <i class="mdi mdi-view-grid"></i>
            </el-radio-button>
          </el-radio-group>

          <el-button type="primary" @click="openReservationCreator" size="small" class="new-button">
            <i class="mdi mdi-plus-circle"></i>
            <span class="new-button__label">{{$t('common.New')}}</span>
          </el-button>

          <el-dropdown size="small">
            <el-button size="small" class="export-button">
              <i class="mdi mdi-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleDownloadCSV('CSV_EXPORT', 'filtered')" :disabled="!$can('read', 'Customer')">
                <span class="mdi mdi-download"> {{ $t('reservation.downloadAllFilteredReservations') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <el-row :gutter="14" class="reservations-content">
        <el-col :span="leftPanelSpan">
          <div class="panel-card">
            <ReservationsList @select="select"></ReservationsList>
          </div>
        </el-col>

        <el-col :span="rightPanelSpan" v-if="showRightPanel">
          <div class="panel-card panel-card--detail">
            <ReservationView @close="closeSelectedReservation" @edit="editSelectedReservation"></ReservationView>
          </div>
        </el-col>
      </el-row>
    </div>

    <WatingDialog :visible="reportLoading"></WatingDialog>
    <ReservationEditor :visible="reservationCreatorVisible" :edit="reservationToEdit" @close="closeReservationCreator" @created="updateReservationList" @updated="updateSelectedReservation"></ReservationEditor>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ReservationEditor from '@/components/reservation/reservation-editor'
import ReservationsList from './components/reservations-list'
import ReservationView from './components/reservation-view'
import ReservationAPI from '@/services/API/reservation'
import WatingDialog from '@/components/waiting-dialog'

export default {
  data() {
    return {
      reportLoading: false,
      leftPanelSpan: 24,
      pageWidth: 0,
      pageHeight: 0,
      rightPanelSpan: 0,
      showRightPanel: false,
      search: '',
      soDialogVisible: false,
      editSelectedSalesOrder: null,
      reservationCreatorVisible: null,
      reservationToEdit: null,
    };
  },
  components: {
    ReservationEditor,
    ReservationsList,
    ReservationView,
    WatingDialog,
  },
  methods: {
    handleDownloadCSV(report, type) {
      this.reportLoading = true;
      return this.getQueryParams()
        .then((params) => {
          return ReservationAPI.downloadReservationExtraction(report, type, params)
            .then(() => {
              this.reportLoading = false;
            })
        })
    },
    select(index) {
      this.selectReservation({ index });
      if (this.pageWidth < 1054) {
        this.leftPanelSpan = 0;
        this.rightPanelSpan = 24;
      } else {
        this.leftPanelSpan = 12;
        this.rightPanelSpan = 12;
      }
      this.showRightPanel = true;
    },
    closeSelectedReservation() {
      this.rightPanelSpan = 0;
      this.leftPanelSpan = 24;
      this.showRightPanel = false;
    },
    updateReservationList() {
      this.invalidateReservationList();
      this.fetchReservations();
    },
    openReservationCreator() {
      this.reservationCreatorVisible = true;
    },
    editSelectedReservation() {
      this.reservationToEdit = this.selectedReservation;
      this.openReservationCreator();
    },
    closeReservationCreator() {
      this.reservationCreatorVisible = false;
      this.reservationToEdit = null;
    },
    updateSelectedReservation(reservationUpdated) {
      this.updateSelecteReservation(reservationUpdated);
    },
    close() {
      this.$router.go(-1);
    },
    setPageWidth() {
      this.pageWidth = document.getElementById('page-panel').offsetWidth;
      this.pageHeight = document.getElementById('page-panel').offsetHeight;
    },
    __resizeHanlder: _.throttle(function () {
      this.setPageWidth();
    }, 700),
    ...mapActions('reservations', ['fetchReservations', 'selectReservation', 'invalidateReservationList', 'setEditReservation', 'updateSelecteReservation', 'changeMode', 'getQueryParams']),
  },
  computed: {
    modeModel: {
      get() { return this.mode},
      set(mode) { this.closeSelectedReservation(); this.changeMode(mode) }
    },
    ...mapState('reservations', ['reservations', 'loading', 'selectedReservation', 'mode']),
  },
  mounted() {
    this.setPageWidth()
  },
  created() {
    this.invalidateReservationList();
    this.fetchReservations();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.reservations-page {
  height: 100%;
  min-height: 100%;
  background: linear-gradient(180deg, #f8fafc 0%, #f3f7fa 38%, #eef3f8 100%);
}

.reservations-shell {
  padding: 10px 10px 4px;
}

.reservations-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #e6edf5;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(37, 56, 88, 0.06);
}

.reservations-toolbar__title-wrap {
  display: flex;
  flex-direction: column;
}

.reservations-toolbar__title {
  margin: 0;
  font-size: 22px;
  line-height: 1.1;
  color: #1f2d3d;
}

.reservations-toolbar__subtitle {
  margin-top: 2px;
  color: #8a97a7;
  font-size: 12px;
}

.reservations-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mode-button i {
  font-size: 13px;
}

.new-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.new-button__label {
  padding-left: 2px;
}

.export-button {
  min-width: 34px;
}

.panel-card {
  background: #ffffff;
  border: 1px solid #e6edf5;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(37, 56, 88, 0.06);
  padding: 10px;
}

.panel-card--detail {
  min-height: 120px;
}

.el-table tr,
.el-table__row {
  background-color: #f3f7fa;
}

@media (max-width: 768px) {
  .reservations-shell {
    padding: 6px;
  }

  .reservations-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 10px;
  }

  .reservations-toolbar__title {
    font-size: 20px;
  }

  .reservations-toolbar__actions {
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .new-button__label {
    display: none;
  }

  .panel-card {
    padding: 8px;
    border-radius: 10px;
  }
}

@media (max-width: 1024px) {
  img.inventory {
    margin-top: 20px;
    height: 175px;
  }
}
</style>
